"use strict";

var _defineProperty = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Model = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var HTML_1 = require("./HTML");

var RendererConfig_1 = require("./RendererConfig");

exports.Model = {
  renderingPage: "https://gateway.pinata.cloud/ipfs/QmVc3UHHL6dhjWuY4cryY3yoEu1HoX8KcFafq3K4ELbZEJ/model-viewer.html",
  getRenderingPreference: function getRenderingPreference(request) {
    var _a, _b;

    if ((_b = (_a = request.media.content) === null || _a === void 0 ? void 0 : _a.type) === null || _b === void 0 ? void 0 : _b.startsWith("model/gltf")) {
      return request.renderingContext === "FULL" ? RendererConfig_1.RenderingPreference.PRIORITY : RendererConfig_1.RenderingPreference.NORMAL;
    }

    return RendererConfig_1.RenderingPreference.INVALID;
  },
  render: function render(props) {
    var _a, _b, _c;

    var mediaURI = ((_a = props.request.media.content) === null || _a === void 0 ? void 0 : _a.uri) || ((_b = props.request.media.animation) === null || _b === void 0 ? void 0 : _b.uri);

    if (!mediaURI) {
      // todo: better error
      return jsx_runtime_1.jsx(react_1.Fragment, {}, void 0);
    }

    var params = new URLSearchParams();
    params.append("src", mediaURI);

    if (props.request.media.image) {
      params.append("poster", (_c = props.request.media.image) === null || _c === void 0 ? void 0 : _c.uri);
    }

    var newProps = _objectSpread({}, props);

    newProps.request.media.content = {
      uri: "".concat(exports.Model.renderingPage, "#").concat(params.toString())
    };
    return jsx_runtime_1.jsx(HTML_1.HTML.render, Object.assign({}, newProps), void 0);
  }
};